/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
function showActionSheet(options, context) {
    var _a;
    var api = 'dd.device.notification.actionSheet';
    var formatInput = function (input) {
        var _a = input.items, items = _a === void 0 ? [] : _a, cancelButtonText = input.cancelButtonText;
        return {
            cancelButton: cancelButtonText || '取消',
            otherButtons: items,
        };
    };
    var formatOutput = function (ret) { return ({
        index: ret === null || ret === void 0 ? void 0 : ret.buttonIndex,
    }); };
    (_a = context === null || context === void 0 ? void 0 : context.DDCall) === null || _a === void 0 ? void 0 : _a.call(context, api, options, {
        formatInput: formatInput,
        formatOutput: formatOutput,
    });
}

export { showActionSheet as default };
